/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import parameters from '@jira/servicedesk__customer-service-support-website-pages/src/__generated__/SupportWebsitePagesQuery$parameters.ts';
import type { SupportWebsitePagesQuery } from '@jira/servicedesk__customer-service-support-website-pages/src/__generated__/SupportWebsitePagesQuery.graphql.ts';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type HelpCenterSettingsSupportWebsitePagesAppEntryPointComponent = EntryPointComponent<
	{
		customPagesQuery: SupportWebsitePagesQuery;
	},
	{},
	{},
	{} | null
>;

export const HelpCenterSettingsSupportWebsitePagesAppEntryPoint: EntryPoint<
	HelpCenterSettingsSupportWebsitePagesAppEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<HelpCenterSettingsSupportWebsitePagesAppEntryPointComponent>(
		/* webpackChunkName: "async-help-center-setting-support-website-pages-app" */ './HelpCenterSettingsSupportWebsitePagesComponent.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({
		context: {
			match: {
				params: { helpCenterId },
			},
		},
		tenantContext: { cloudId, activationId },
	}: EntryPointRouteParams) => ({
		queries: {
			customPagesQuery: {
				parameters,
				variables: {
					cloudId,
					helpCenterARI: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
					NUMBER_OF_PAGES_INITIAL_FETCH: 300,
				},
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
			},
		},
	}),
});
